import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Table from '@ts-core/components/Table/TSTable';
import ScoreIcon from '@ts-core/components/ScoreIcon';

import { formatValue } from '@ts-core/utils/dataTableUtils';

const LessonsStatsTable = (props) => {
  const intl = useIntl();
  const { loading, error, lessonsStats } = props;

  const { students = [], lessons } = lessonsStats || {};

  const columns = useMemo(() => {
    const rColumns = [
      {
        Header: intl.formatMessage({ id: 'assignmentResultsTable.student' }),
        value: intl.formatMessage({ id: 'assignmentResultsTable.student' }),
        accessor: 'name',
        sortable: true,
      },
    ];

    lessons?.forEach((lesson) => {
      rColumns.push({
        Header: lesson.name,
        value: lesson.name,
        accessor: `attendanceData.${lesson._id}`,
        valueTransformer: (value) => <ScoreIcon score={value ? 1 : -1} />,
        Footer: formatValue(lesson.studentsCount, lesson.totalStudents),
      });
    });

    rColumns.push({
      Header: intl.formatMessage({ id: 'attendances' }),
      accessor: 'totalAttendances',
      valueTransformer: (value) => formatValue(value, lessons?.length || 0),
      sortable: true,
    });

    return rColumns;
  }, [lessons, intl]);

  return (
    <Table
      data={lessons?.length > 0 ? students : []}
      columns={columns}
      loading={loading}
      error={error}
    />
  );
};

LessonsStatsTable.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  lessonsStats: PropTypes.object,
};

LessonsStatsTable.defaultProps = {
  loading: false,
  error: undefined,
  lessonsStats: {},
};

export default LessonsStatsTable;
